import React, { useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import { useParams } from 'react-router-dom';
import HttpClient from '../../utils/HttpClient';
import toast from 'react-hot-toast';
import { useEffect } from 'react';
import moment from 'moment';
import offer from '../../Images/offer_10785653.png'

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}

const PurchaseHistory = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [purchasedData, setpurchasedData] = useState([])
    const params = useParams()

    const getPurchases = async () => {
        setIsLoading(true)
        const data = {
            "userId": params?.id
        }
        const res = await HttpClient.requestData("users-purchase-histories", "POST", data)
        if (res && res?.status) {
            // toast.success(res?.message)
            setpurchasedData(res?.data)
            setIsLoading(false)

        }
        else {
            setIsLoading(false)
            // toast.error(res?.message || "Error Occurred")
        }
    }
    useEffect(() => {
        if (params?.id) {
            getPurchases();
        }
    }, [params?.id])

    return (
        <div className="d-flex justify-content-end mr-2">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        PURCHASE HISTORY
                    </div>
                    <div className="container">
                        <section className="mx-auto my-5 row" >

                            {
                                purchasedData?.map((item, i) => {
                                    return (<>
                                        <div className="col-md-4 mb-4">
                                            <div className="card">
                                                <div className="bg-image hover-overlay ripple" data-mdb-ripple-color="light">
                                                    <img
                                                        src={item?.Offer?.partnerLogo}
                                                        className="img-fluid"
                                                    />
                                                    <a href="#!">
                                                        <div
                                                            className="mask"
                                                            style={{ backgroundColor: "rgba(251, 251, 251, 0.15)" }}
                                                        />
                                                    </a>
                                                </div>
                                                <div className="card-body">
                                                    <h5 className="card-title">
                                                        <div className=" d-flex font-weight-bold" style={{ fontSize: "18px" }}>

                                                            <p>{item?.Offer?.partnerName}( PARTNER ) </p>

                                                        </div>
                                                    </h5>
                                                    <ul className="list-unstyled list-inline mb-0">

                                                        <li className="list-inline-item">
                                                            <p className="text-muted">Purchasing Date: {moment(item?.createdOn).format("DD-MM-YYYY")}</p>
                                                        </li>
                                                    </ul>

                                                    <p className="mb-2"><img
                                                        src={offer}
                                                        className="img-fluid" style={{ width: "35px", height: "35px" }}
                                                    /> {item?.Offer?.offerType}</p>
                                                    <p className="mb-2"><i className="fa-solid fa-coins mx-1" style={{ color: "#f7aa02", fontSize: "25px" }}></i>{item?.Offer?.reddemingPoints}</p>
                                                    <p className="card-text">
                                                        {item?.Offer?.voucherDesc}.
                                                    </p>
                                                    <hr className="my-4" />
                                                    <p className="lead">
                                                        <strong>Offer availability date</strong>
                                                    </p>
                                                    <ul className="list-unstyled list-inline d-flex justify-content-between">
                                                        <li className="list-inline-item me-0">
                                                            <div className="chip me-0">{moment(item?.Offer?.offerExpiryDate).format("DD-MM-YYYY")}</div>
                                                        </li>

                                                    </ul>
                                                    <a href={item?.Offer?.profileLink} target="_blank" className="btn btn-link link-secondary p-md-1 mb-0">
                                                        Click to go Partner's Profile
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </>)
                                })
                            }

                        </section>
                    </div>






                </section>
            </div>

        </div>

    )
}

export default PurchaseHistory